var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Security + Provider"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9145 -10719C-9145 -10720.1 -9144.1 -10721 -9143 -10721H8094C8095.11 -10721 8096 -10720.1 8096 -10719V937C8096 938.104 8095.11 939 8094 939H-9143C-9144.1 939 -9145 938.104 -9145 937V-10719Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9143 -10720H8094V-10722H-9143V-10720ZM8095 -10719V937H8097V-10719H8095ZM8094 938H-9143V940H8094V938ZM-9144 937V-10719H-9146V937H-9144ZM-9143 938C-9143.55 938 -9144 937.553 -9144 937H-9146C-9146 938.656 -9144.66 940 -9143 940V938ZM8095 937C8095 937.552 8094.55 938 8094 938V940C8095.66 940 8097 938.656 8097 937H8095ZM8094 -10720C8094.55 -10720 8095 -10719.6 8095 -10719H8097C8097 -10720.7 8095.66 -10722 8094 -10722V-10720ZM-9143 -10722C-9144.66 -10722 -9146 -10720.7 -9146 -10719H-9144C-9144 -10719.6 -9143.55 -10720 -9143 -10720V-10722Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "PPC VC",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-742 -425)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3084",
    opacity: 0.3,
    x: -742,
    y: -365,
    width: 1440,
    height: 964,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1116601809",
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-259 -165C-259 -170.523 -254.523 -175 -249 -175H205C210.523 -175 215 -170.523 215 -165V337C215 342.523 210.523 347 205 347H-249C-254.523 347 -259 342.523 -259 337V-165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-249 -178C-256.18 -178 -262 -172.18 -262 -165V337C-262 344.18 -256.18 350 -249 350H205C212.18 350 218 344.18 218 337V-165C218 -172.18 212.18 -178 205 -178H-249Z",
    stroke: "#DDE2EE",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1116601649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1116601652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1116601648"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -87.5,
    y: -3,
    width: 125,
    height: 31,
    rx: 1.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -87.5,
    y: -3,
    width: 125,
    height: 31,
    rx: 1.5,
    stroke: "#DDE2EE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "time-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5C22 18.0228 17.5228 22.5 12 22.5ZM12 20.5C16.4183 20.5 20 16.9183 20 12.5C20 8.08172 16.4183 4.5 12 4.5C7.58172 4.5 4 8.08172 4 12.5C4 16.9183 7.58172 20.5 12 20.5ZM13 12.5H17V14.5H11V7.5H13V12.5Z",
    fill: "#516CD3"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -279,
    y: -195,
    width: 534,
    height: 582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-742 -425)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueClock);
export default __webpack_public_path__ + "static/media/BlueClock.2cb752c963a49b2eaca121c35cc836de.svg";
export { ForwardRef as ReactComponent };